import React, { Component } from 'react';
import { Modal, Select, Input, Form, message, Row, Col } from 'antd';
import SearchInput from '../../common/SearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;
const FormItem = Form.Item;

class CreateForm extends Component {
    state = {
        customerTypeList: [],
    }

    componentDidMount() {
        const { form: { getFieldDecorator } } = this.props;
        getFieldDecorator('companyOptions', { initialValue: [] });
        this.queryCustomerType();
    }

    queryCustomerType = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryCustomerType,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    customerTypeList: res.customerTypeList,
                });
            }
        };
        $.sendRequest(options);
    }

     // 客户名称
     companySelectChange = value => {
        const { form: { setFieldsValue } } = this.props;
        const params = {};
        if (value) {
            params.customerId = value.key;
        } else {
            params.customerId = '';
        }
        setFieldsValue({ ...params });
    }

    parseCompanyData = (res, value) => {
        const { form: { setFieldsValue } } = this.props;
        if ((res.data || res.datas) ) {
            const sourceData = res.data;
            const data = sourceData.map(item => ({
                text: `${item.customerCompanyName}`,
                value: item.customerCompanyId,
                customerJdeCode: item.customerCompanyCode,
            }));
            setFieldsValue({ companyOptions: data });
        } else {
            setFieldsValue({ companyOptions: [] });
        }
    }

    render() {
        const { isEdit, params = {}, form: { getFieldDecorator, getFieldValue } } = this.props;
        const { userCompellation, employeeCode } = params;
        const { customerTypeList } = this.state;
        const formItemLayout = {
            labelCol: {
                sm: { span: 7 },
                md: { span: 7 },
            },
            wrapperCol: {
                sm: { span: 16, offset: 1 },
                md: { span: 16, offset: 1 },
            },
        };
        const customerId = getFieldValue('customerId') || undefined;
        const customerCompanyName = getFieldValue('customerCompanyName') || undefined;
        const companyOptions = getFieldValue('companyOptions') || [];
        const customerTypeOption = customerTypeList.map(i => <Option key={i.customerTypeId}>{i.customerTypeName}</Option>);
        return (
            <Form>
                <FormItem {...formItemLayout} label="人员">
                    {`${userCompellation}[${employeeCode}]`}
                </FormItem>
                <FormItem {...formItemLayout} label="客户类型">
                    {
                        getFieldDecorator('customerTypeId', {
                            rules: [{
                                required: true,
                                message: '请选择客户类型'
                            }],
                        })(
                            <Select
                                placeholder="请选择"
                                style={{width:220}}
                            >
                                {customerTypeOption}
                            </Select>
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="客户名称">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('customerId', {
                                    rules: [{
                                        required: true,
                                        message: '请输入客户名称'
                                    }]
                                })(
                                    <SearchInput
                                        isEdit={isEdit}
                                        keyword='customerCompanyName'
                                        style={{ width: 220 }}
                                        placeholder="请输入客户名称检索"
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        initValue={{ key: customerId, label: customerCompanyName }}
                                        dataSource={companyOptions}
                                        parseData={this.parseCompanyData}
                                        handleSelect={this.companySelectChange}
                                    />
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout} label="主要对接人">
                    {
                        getFieldDecorator('mainContactUserName')(
                            <Input style={{ width: 220 }} placeholder="请输入" />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="联系电话">
                    {
                        getFieldDecorator('mainContactUserMobile')(
                            <Input style={{ width: 220 }} placeholder="请输入" />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="邮箱">
                    {
                        getFieldDecorator('mainContactUserMail')(
                            <Input style={{ width: 220 }} placeholder="请输入" />
                        )
                    }
                </FormItem>
            </Form>
        );
    }
}

class UpdateCustomRecord extends Component {
    state = {
        params: {},
        visible: false,
        confirmLoading: false,
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
    }

    hide = () => {
        this.setState({
            visible: false
        });
    }

    confirm = () => {
        this.formRef.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const {
                customerId = '',
                companyOptions = [],
            } = values;
            if (customerId) {
                const isExist = companyOptions.some(item => item.value == customerId);
                if (!isExist) {
                    message.warning('请选择正确的公司名称');
                    return;
                }
            }

            const { isEdit, params } = this.state;
            const { userId, pmCustomerRecordId } = params;

            const saveParams = {
                userId,
                ...values,
                pmCustomerRecordId,
            };
            delete saveParams.companyOptions;

            this.setState({ confirmLoading: true });
            const url = isEdit ? API_URL.user.editPmCustomerRecord : API_URL.user.addPmCustomerRecord;
            const options = {
                method: 'POST',
                url,
                data: { ...saveParams },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.setState({ confirmLoading: false }, () => {
                        this.props.loadData(userId);
                    });
                },
                errorResult: () => {
                    this.setState({ confirmLoading: false });
                },
            }
            $.sendRequest(options);
        });
    }

    render() {
        const { isEdit, confirmLoading, visible, params } = this.state;
        const newProps = {};
        const objArr = Object.entries(params);
        objArr.forEach((arr) => {
            if (arr[0] == 'customerTypeId') {
                newProps[arr[0]] = {
                    value: arr[1] ? String(arr[1]) : undefined,
                };
            } else {
                newProps[arr[0]] = {
                    value: arr[1],
                };
            }
        });
        const mapPropsToFields = () => ({
            ...newProps,
        });
        const CreateForms = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}客户记录`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                confirmLoading={confirmLoading}
                maskClosable={false}
                width={550}
            >
                <div style={{ margin: '10px 0' }}>
                    <CreateForms
                        params={params}
                        isEdit={isEdit}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default UpdateCustomRecord;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/UpdateCustomRecord.js